const RequestManager = {
  endPoint: `https://apidev.daftareshoma.com`,
  apiCoreEndPoint: 'https://coreapi.dev.daftareshoma.com',

  // endPoint: `https://api.daftareshoma.com`,
  // apiCoreEndPoint: 'https://coreapi.daftareshoma.com',

  // endPoint: `https://api.daftareshoma.com`,
  // apiCoreEndPoint: 'https://coreapi.daftareshoma.com',
  version: ``,
  prefix: ``,
  controllers: {
    Auth: {
      name: 'api/RegisterUser',
      actions: {
        CheckEmail: {
          name: '/CheckNotExistsEmail',
          path: '/CheckNotExistsEmail',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        UpdateUser: {
          name: '/UpdateUser',
          path: '/UpdateUser',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
      },



    },
    Token: {
      name: '',
      actions: {
        Token: {
          name: 'token',
          path: '/token',
          method: 'post',
          defaul_cach_time: 0,
          // enable_message: true,
          // additionalHeaders: null,
          // successMessage: "ورود با موفقیت انجام شد"
        },
      },
    },
    CareerField: {
      name: '/api/CareerField',
      actions: {
        CareerField: {
          name: 'GetAll',
          path: '/GetAll',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
      }
    },
    Register: {
      name: '/api/RegisterUser',
      actions: {
        RegisterUser: {
          name: 'RegisterUser',
          path: '/RegisterUser',
          method: 'post',
          // enable_message: true,
          // defaul_cach_time: 0,
          // additionalHeaders: null,
          // successMessage: "ثبت نام با موفقیت انجام شد"
        },
      },
    },
    Notification: {
      name: 'api/Notification',
      actions: {
        GetNotificationCount: {
          name: 'getCustomerUnreadNotificationCount',
          path: '/getCustomerUnreadNotificationCount',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
      },
    },
    Captcha: {
      name: 'api/Captcha',
      actions: {
        Captcha: {
          name: 'InsertCaptchaVerifiedLoginHistory',
          path: '/InsertCaptchaVerifiedLoginHistory',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
      },
    },
    CreditDetails: {
      name: 'api/creditDetails',
      actions: {
        GetCreditDetails: {
          name: '',
          path: '/getCreditDetails',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        }
      }
    },
    Dashboard: {
      name: 'api/dashboard',
      actions: {
        GetLatestCustomerCalls: {
          name: '',
          path: '/getLatestCustomerCalls',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        SecratryInfoService: {
          name: '',
          path: '/getDashboardSecretaryInfo',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        IvrInfoService: {
          name: '',
          path: '/getDashboardIvrInfo',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        FaxInfoService: {
          name: '',
          path: '/getDashboardFaxInfo',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        DashboardData: {
          name: '',
          path: '/GetDashboardData',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetLatestCustomerCalls: {
          name: '',
          path: '/GetLatestCustomerCalls',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
      },
    },
    Profile: {
      name: 'api/profile',
      actions: {
        GetProfile: {
          name: 'GetProfile',
          path: '/get',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        ResendMobileVerificatiionCode: {
          name: 'ResendMobileVerificatiionCode',
          path: '/ResendMobileVerificationCode',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: "کد اعتبارسنجی به تلفن همراه شما پیامک شد"
        },
        VerifyMobile: {
          name: 'VerifyMobile',
          path: '/VerifyMobile',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetAllProvincesWithCities: {
          name: 'GetAllProvincesWithCities',
          path: '/GetAllProvincesWithCities',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        Save: {
          name: 'Save',
          path: '/Save',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: "تغییرات شما با موفقیت ذخیره شد."
        },
        ChangePassword: {
          name: 'ChangePassword',
          path: '/ChangePassword',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: "تغییر پسورد شما با موفقیت انجام شد"
        }
      }
    },
    EmailVerification: {
      name: 'api/EmailVerification',
      actions: {
        ResendEmailVerificationEmail: {
          name: 'ResendEmailVerificationEmail',
          path: '/ResendEmailVerificationEmail',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          // enable_message: true,
          // successMessage: "Email sent"
        },
        ChangeEmailVerificationEmail: {
          name: 'ChangeEmailVerificationEmail',
          path: '/ChangeEmailVerificationEmail',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: "ایمیل اعتبار سنجی به ایمیل جدید شما ارسال شد"
        },
        AddNewEmailRequest: {
          name: 'AddNewEmailRequest',
          path: '/AddNewEmailRequest',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,

        },
        RejectNewEmail: {
          name: 'RejectNewEmail',
          path: '/RejectNewEmail',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        }
      }
    },
    Instruction: {
      name: 'api/Instruction',
      actions: {
        GetInstruction: {
          name: 'GetInstruction',
          path: '/Get',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        SaveInstruction: {
          name: 'SaveInstruction',
          path: '/Save',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          // enable_message: true,
          // successMessage: "تنظیمات با موفقیت ثبت شد"
        }

      }

    },

    InstructionFiles: {
      name: 'InstructionFiles',
      actions: {
        GetInstructionFile: {
          name: 'GetInstructionFile',
          path: '/Rahnama-Monshi.pdf',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
          successMessage: 'file download successfull'
        }
      }
    },
    CustomerLine: {
      name: 'api/customerLine',
      actions: {
        GetCustomerLine: {
          name: 'GetCustomerLine',
          path: '/getCustomerNumbers2',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetCustomerLines: {
          name: 'GetCustomerLines',
          path: '/GetCustomerLines',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        insertVoicemailUrl: {
          name: 'InsertVoicemailUrl',
          path: '/InsertVoicemailUrl',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: "تنظیمات با موفقیت انجام شد",
        },
        getVoicemailUrl: {
          name: 'GetVoicemailUrl',
          path: '/GetVoicemailUrl',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        generalLineSettings: {
          name: 'GetGeneralLineSettings',
          path: '/GetGeneralLineSettings',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        SetGeneralLineSettings: {
          name: 'SetGeneralLineSettings',
          path: '/SetGeneralLineSettings',
          method: 'post',
          defaul_cach_time: 0,
          enable_message: true,
          successMessage: "اطلاعات با موفقیت ثبت گردید",
          additionalHeaders: null,
        },
      }
    },
    CustomerMember: {
      name: 'api/CustomerMember',
      actions: {
        GetCustomerMember: {
          name: 'GetCustomerMember',
          path: '/GetCustomerMemberContactInfo',
          method: 'get',
        },
        customerMembers: {
          name: 'GetCustomerMembers',
          path: '/GetCustomerMembers',
          method: 'get',
        },
        NewCustomerMember: {
          name: 'NewCustomerMember',
          path: '/NewCustomerMember',
          method: 'post',
          enable_message: true,
          // successMessage: "همکار جدید با موفقیت به لیست همکاران افزوده شد",
        },
        Delete: {
          name: 'Delete',
          path: '/Delete',
          method: 'delete',
          enable_message: true,
          successMessage: "همکار با موفقیت حذف شد",
        },
        UpdateCustomerMember: {
          name: 'UpdateCustomerMember',
          path: '/UpdateCustomerMember',
          method: 'post',
          enable_message: true,
          // successMessage: "اطلاعات همکار با موفقیت به روز شد",
        },
        ChangeMemberNotificationSetting: {
          name: 'ChangeMemberNotificationSetting',
          path: '/ChangeMemberNotificationSetting',
          method: 'post',
          enable_message: true,
          successMessage: " تغییرات با موفقیت ذخیره شد",
        },
        GetCallTransferCustomerLineByCustomerMember: {
          name: 'GetCallTransferCustomerLineByCustomerMember',
          path: '/GetCallTransferCustomerLineByCustomerMember',
          method: 'get',
          enable_message: false,
        },
        GetCustomerMemberQueueByCustomerMember: {
          name: 'GetCustomerMemberQueueByCustomerMember',
          path: '/GetCustomerMemberQueueByCustomerMember',
          method: 'get',
          enable_message: false,
        },
        GetCustomerMemberMemberShips: {
          name: 'GetCustomerMemberMemberShips',
          path: '/GetCustomerMemberMemberShips',
          method: 'get',
          enable_message: false,
        }
      }

    },

    MusicOnHold: {
      name: 'api/MusicOnHold',
      actions: {
        GetAllMusicOnHold: {
          name: 'GetAllMusicOnHold',
          path: '/GetAllMusicOnHold',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        }
      }
    },

    IvrSettings: {
      name: 'api/IvrSettings',
      actions: {
        Get: {
          name: 'Get',
          path: '/Get',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        Save: {
          name: 'Save',
          path: '/Save',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

      }
    },
    Tts: {
      name: 'api/Tts',
      actions: {
        GetAudioLink: {
          name: 'GetAudioLink',
          path: '/GetAudioLink',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        }
      }
    },
    UserManagement: {
      name: 'api/UserManagement',
      actions: {
        SendResetPasswordEmail: {
          name: 'SendResetPasswordEmail',
          path: '/SendResetPasswordEmail',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,

        },
        setNewPassword: {
          name: 'setNewPassword',
          path: '/setNewPassword',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: " رمز عبور با موفقیت تغییر کرد"
        }
      }
    },
    CustomerCall: {
      name: 'api/CustomerCall',
      actions: {
        GetCustomerCallTypes: {
          name: 'GetCustomerCallTypes',
          path: '/GetCustomerCallTypes',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetURLLink: {
          name: 'GetURLLink',
          path: '/GetURLLink',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        Search: {
          name: 'Search',
          path: '/Search',
          method: 'post',
          defaul_cach_time: 0,
          enable_message: false,
          additionalHeaders: null,
        },
        RecordUrlList: {
          name: 'RecordUrlList',
          path: '/RecordUrlList',
          method: 'get',
          defaul_cach_time: 0,
          enable_message: false,
          additionalHeaders: null,
        },

      }
    },

    Contact: {
      name: 'api/Contact',
      actions: {
        getContacts: {
          name: 'GetContacts',
          path: '/GetContacts',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        getAllContact: {
          name: 'GetAllContact',
          path: '/GetAllContact',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        getContact: {
          name: 'GetContact',
          path: '/GetContact',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        getContactsByPhoneBookId: {
          name: 'GetContactsByPhoneBookId',
          path: '/GetContactsByPhoneBookId',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        addContact: {
          name: 'AddContact',
          path: '/AddContact',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: 'عملیات با موفقیت انجام شد'
        },
        updateContact: {
          name: 'UpdateContact',
          path: '/UpdateContact',
          method: 'patch',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: 'عملیات با موفقیت انجام شد'
        },
        removeFromPhoneBookContact: {
          name: 'RemoveFromPhoneBookContact',
          path: '/RemoveFromPhoneBookContact',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        removeContact: {
          name: 'RemoveContact',
          path: '/RemoveContact',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: 'عملیات حذف با موفقیت انجام شد'
        },
        moveByPhoneBookIds: {
          name: 'moveByPhoneBookIds',
          path: '/MoveByPhoneBookIds',
          method: 'patch',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: 'عملیات با موفقیت انجام شد'
        },
        copyByPhoneBookIds: {
          name: 'CopyByPhoneBookIds',
          path: '/CopyByPhoneBookIds',
          method: 'patch',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: 'عملیات با موفقیت انجام شد'
        },
        moveByContactIds: {
          name: 'moveByContactIds',
          path: '/MoveByContactIds',
          method: 'patch',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: 'عملیات با موفقیت انجام شد'
        },
        copyByContactIds: {
          name: 'CopyByContactIds',
          path: '/CopyByContactIds',
          method: 'patch',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: 'عملیات با موفقیت انجام شد'
        },
        changeIsInBlackListByContactIds: {
          name: 'ChangeIsInBlackListByContactIds',
          path: '/ChangeIsInBlackListByContactIds',
          method: 'patch',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: 'عملیات با موفقیت انجام شد'
        },


      },

    },
    CustomerDocuments: {
      name: 'api/CustomerDocuments',
      actions: {
        GetCustomerDocuments: {
          name: 'GetCustomerDocuments',
          path: '/GetCustomerDocuments',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        Save: {
          name: 'GetCustomerDocuments',
          path: '/Save',
          method: 'post',
          defaul_cach_time: 0,

          additionalHeaders: null,
          enable_message: true,
          successMessage: "فایل شما با موفقیت اپلود شد."
        },
        DeleteById: {
          name: 'GetCustomerDocuments',
          path: '/DeleteById',
          method: 'delete',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: "فایل شما با موفقیت حذف شد"
        },
        Delete: {
          name: 'GetCustomerDocuments',
          path: '/Delete',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,
        },
        getNationalCardCustomerDocumentStatus: {
          name: 'getNationalCardCustomerDocumentStatus',
          path: '/getNationalCardCustomerDocumentStatus',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,
        }


      }
    },

    LineSettings: {
      name: 'api/LineSettings',
      actions: {

        customerLineServices: {
          name: 'GetCustomerLineServices',
          path: '/GetCustomerLineServices',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        callReportSettings: {
          name: 'GetCallReportSettings',
          path: '/GetCallReportSettings',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        lineFaxSettings: {
          name: 'GetLineFaxSettings',
          path: '/GetLineFaxSettings',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        lineVoicemailSettings: {
          name: 'GetLineVoicemailSettings',
          path: '/GetLineVoicemailSettings',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

        SetCallReportSettings: {
          name: 'SetCallReportSettings',
          path: '/SetCallReportSettings',
          method: 'post',
          defaul_cach_time: 0,
          enable_message: true,
          successMessage: "اطلاعات با موفقیت ثبت گردید",
          additionalHeaders: null,
        },
        SetLineFaxSettings: {
          name: 'SetLineFaxSettings',
          path: '/SetLineFaxSettings',
          method: 'post',
          defaul_cach_time: 0,
          enable_message: true,
          successMessage: "اطلاعات با موفقیت ثبت گردید",
          additionalHeaders: null,
        },
        SetLineVoicemailSettings: {
          name: 'SetLineVoicemailSettings',
          path: '/SetLineVoicemailSettings',
          method: 'post',
          defaul_cach_time: 0,
          enable_message: true,
          successMessage: "اطلاعات با موفقیت ثبت گردید",
          additionalHeaders: null,
        },
        getLineSeparationSettings: {
          name: 'GetLineSeparationSettings',
          path: '/GetLineSeparationSettings',
          method: 'get',
          defaul_cach_time: 0,
          enable_message: false,
          additionalHeaders: null,
        }
      },

    },
    directOutgoingCallPassword: {
      name: 'api/directOutgoingCallPassword',
      actions: {
        passwordStatus: {
          name: 'GetPasswordStatus',
          path: '/GetPasswordStatus',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        SetPasswordStatus: {
          name: 'SetPasswordStatus',
          path: '/SetPasswordStatus',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        SetPassword: {
          name: 'set',
          path: '/set',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: "اطلاعات با موفقیت ثبت گردید",
        },

      },

    },
    CallQueueReport: {
      name: 'api/CallQueueReport',
      actions: {
        Search: {
          name: 'Search',
          path: '/Search',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetCallQueueReportByRecordName: {
          name: 'GetCallQueueReportByRecordName',
          path: '/GetCallQueueReportByRecordName',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        ReportCallQueueByDate: {
          name: 'ReportCallQueueByDate',
          path: '/ReportCallQueueByDate',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        WeeklyReportCallQueue: {
          name: 'WeeklyReportCallQueue',
          path: '/WeeklyReportCallQueue',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

        GetReportCallQueueByDateForListQueues: {
          name: 'GetReportCallQueueByDateForListQueues',
          path: '/GetReportCallQueueByDateForListQueues',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
      },
    },

    charge: {
      name: 'api/Charge',
      actions: {
        getGateways: {
          name: 'GetGateways',
          path: '/GetGateways',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        getMinimumChargeAmount: {
          name: 'GetMinimumChargeAmount',
          path: '/GetMinimumChargeAmount',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        getVatPercent: {
          name: 'getVatPercent',
          path: '/getVatPercent',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        makeCharge: {
          name: 'MakeCharge',
          path: '/MakeCharge',
          method: 'post',
          enable_message: true,
          additionalHeaders: null,
          successMessage: "شارژ با موفقیت انجام شد"
        },
        prepareForGatewayToMakeCharge: {
          name: 'PrepareForGatewayToMakeCharge',
          path: '/PrepareForGatewayToMakeCharge',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

      },

    },

    customerCredit: {
      name: 'api/CustomerCredit',
      actions: {
        getCurrentCustomerCreditAmount: {
          name: 'GetCurrentCustomerCreditAmount',
          path: '/GetCurrentCustomerCreditAmount',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },


      },

    },
    googleAnalyticsECommerce: {
      name: 'api/googleAnalyticsECommerce',
      actions: {
        getPurchaseInfo: {
          name: 'getPurchaseInfo',
          path: '/getPurchaseInfo',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },


      },

    },
    company_info: {
      name: 'api/company_info',
      actions: {
        save: {
          name: 'save',
          path: '/save',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: "اطلاعات با موفقیت ثبت گردید",
        },
        get: {
          name: 'get',
          path: '/get',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,
        }

      }
    },
    queue: {
      name: 'api/CallQueue',
      actions: {
        GetAllCallQueue: {
          name: 'GetAllCallQueue',
          path: '/GetAllCallQueue',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,
        },
        InsertCallQueue: {
          name: 'InsertCallQueue',
          path: '/InsertCallQueue',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          // enable_message: true,
          // successMessage: "اضافه کردن صف با موفقیت انجام شد"
        },
        UploadDefaultCallQueueMusic: {
          name: 'UploadDefaultCallQueueMusic',
          path: '/UploadDefaultCallQueueMusic',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          // enable_message: true,
          // successMessage: "      شد"
        },
        UpdateCallQueue: {
          name: 'UpdateCallQueue',
          path: '/UpdateCallQueue',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          // successMessage: "صف با موفقیت ویرایش شد"
        },
        DeleteCallQueue: {
          name: 'DeleteCallQueue',
          path: '/DeleteCallQueue',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          // successMessage: "صف مورد نظر با موفقیت حذف شد"
        },
        GetActiveCallQueue: {
          name: 'GetActiveCallQueue',
          path: '/GetActiveCallQueue',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          // successMessage: "صف با موفقیت ویرایش شد"
        },
        UpsertCallQueueCustomerMember: {
          name: 'UpsertCallQueueCustomerMember',
          path: '/UpsertCallQueueCustomerMember',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,
        },
        DeleteCustomerMemberCallQueue: {
          name: 'DeleteCustomerMemberCallQueue',
          path: '/DeleteCustomerMemberCallQueue',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,
        },


      }
    },

    paiedInvoice: {
      name: 'api/Transaction',
      actions: {
        GetFreeProposedNumbers: {
          name: 'GetFreeProposedNumbers',
          path: '/GetFreeProposedNumbers',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetAllPaidInvoices: {
          name: 'GetAllPaidInvoices',
          path: '/GetAllPaidInvoices',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,

        },
        GetInvoiceInPortal: {
          name: 'GetInvoiceInPortal',
          path: '/GetInvoiceInPortal',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,

        },
        SetIssueFactorType: {
          name: 'SetIssueFactorType',
          path: '/SetIssueFactorType',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,
        }

      },


    },

    IvrFile: {
      name: 'api/IvrFile',
      actions: {
        Upload: {
          name: 'Upload',
          path: '/Upload',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,
        }
      }


    },

    PortalPurchase: {
      name: 'api/PortalPurchase',
      actions: {
        getCandidateIvrProducts: {
          name: 'getCandidateIvrProducts',
          path: '/getCandidateIvrProducts',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,
        },
        getCandidateSecretaryProducts: {
          name: 'getCandidateSecretaryProducts',
          path: '/getCandidateSecretaryProducts',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,
        },
        getCandidateFaxProducts: {
          name: 'getCandidateFaxProducts',
          path: '/getCandidateFaxProducts',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,
        },
        getNumbersCountToBeSelected: {
          name: 'getNumbersCountToBeSelected',
          path: '/getNumbersCountToBeSelected',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,
        },
        getApplicableContractTypes: {
          name: 'getApplicableContractTypes',
          path: '/getApplicableContractTypes',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,
        },
        generateHtmlPreinvoiceForReturningCustomer: {
          name: 'generateHtmlPreinvoiceForReturningCustomer',
          path: '/generateHtmlPreinvoiceForReturningCustomer',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,
        },
        Buy: {
          name: 'Buy',
          path: '/Buy',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,
        },
        getCities: {
          name: 'getCities',
          path: '/getCities',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,
        },
        isFreeProduct: {
          name: 'IsFreeProduct',
          path: '/IsFreeProduct',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,
        },
        generateHtmlPreInvoiceForNewlyRegisteredCustomer: {
          name: 'GenerateHtmlPreinvoiceForNewlyRegisteredCustomer',
          path: '/GenerateHtmlPreinvoiceForNewlyRegisteredCustomer',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,
        },
      }


    },

    line: {
      name: 'api/Line',
      actions: {
        GetFreeProposedNumbers: {
          name: 'GetFreeProposedNumbers',
          path: '/GetFreeProposedNumbers',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        get: {
          name: 'get',
          path: '/get',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,

        },

        GetInvoiceInPortal: {
          name: 'GetInvoiceInPortal',
          path: '/GetInvoiceInPortal',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,

        },
        SetIssueFactorType: {
          name: 'SetIssueFactorType',
          path: '/SetIssueFactorType',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,
        }
        ,
        SearchFreeProposedNumbers: {
          name: 'SearchFreeProposedNumbers',
          path: '/SearchFreeProposedNumbers',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,
        },
        GetProposedNumbers: {
          name: 'GetProposedNumbers',
          path: '/GetProposedNumbers',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,
        },
        SearchProposedNumbers: {
          name: 'SearchProposedNumbers',
          path: '/SearchProposedNumbers',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,
        }

      },


    },
    BankGateway: {
      name: "api/BankGateway",
      actions: {
        PrepareForGateway: {
          name: 'PrepareForGateway',
          path: '/PrepareForGateway',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
      }
    },
    LineReservation: {
      name: "api/LineReservation",
      actions: {
        TryReserveRequestedLines: {
          name: 'TryReserveRequestedLines',
          path: '/TryReserveRequestedLines',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
      }
    },
    PurchaseInfoProvider: {
      name: "api/PurchaseInfoProvider",
      actions: {
        GetPurchaseInfo: {
          name: 'GetPurchaseInfo',
          path: '/GetPurchaseInfo',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
      }
    },
    CustomerAttachment: {
      name: "api/CustomerAttachment",
      actions: {
        Save: {
          name: 'Save',
          path: '/Save',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetCustomerAttachments: {
          name: 'GetCustomerAttachments',
          path: '/GetCustomerAttachments',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        Delete: {
          name: 'Delete',
          path: '/Delete',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        getCustomerAttachmentById: {
          name: 'getCustomerAttachmentById',
          path: '/getCustomerAttachmentById',
          method: 'post',
          defaul_cach_time: 0,

          additionalHeaders: null,
        }
      }
    },
    CallReport: {
      name: "api/CallReport",
      actions: {
        Search: {
          name: 'Search',
          path: '/Search',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetNumbersByCustomerId: {
          name: 'GetNumbersByCustomerId',
          path: '/GetNumbersByCustomerId',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        UpdateStarStatus: {
          name: 'UpdateStarStatus',
          path: '/UpdateStarStatus',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        }
      }
    },
    CallReportNote: {
      name: "api/CallReportNote",
      actions: {
        Save: {
          name: 'Save',
          path: '/Save',
          method: 'post',
          enable_message: true,
          successMessage: "یادداشت با موفقیت ثبت شد",
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetCallReportDetails: {
          name: 'GetCallReportDetails',
          path: '/GetCallReportDetails',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        }
      }
    },
    Fax: {
      name: "api/Fax",
      actions: {
        GetFaxInbox: {
          name: 'GetFaxInbox',
          path: '/GetFaxInbox',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetFaxOutbox: {
          name: 'GetFaxOutbox',
          path: '/GetFaxOutbox',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        SendNewFax: {
          name: 'SendNewFax',
          path: '/SendNewFax',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        HasCustomerIvrProduct: {
          name: 'HasCustomerIvrProduct',
          path: '/HasCustomerIvrProduct',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetCustomerFaxNumbers: {
          name: 'GetCustomerFaxNumbers',
          path: '/GetCustomerFaxNumbers',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        DownloadFile: {
          name: 'DownloadFile',
          path: '/DownloadFile',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        DownloadInboxFile: {
          name: 'DownloadInboxFile',
          path: '/DownloadInboxFile',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        DeleteInboxItem: {
          name: 'DeleteInboxItem',
          path: '/DeleteInboxItem',
          method: 'get',
          defaul_cach_time: 0,
          enable_message: true,
          successMessage: "درخواست با موفقیت انجام شد",
          additionalHeaders: null,
        },
        ReSendFax: {
          name: 'ReSendFax',
          path: '/ReSendFax',
          method: 'get',
          defaul_cach_time: 0,
          enable_message: false,
          // successMessage: "درخواست با موفقیت انجام شد",
          additionalHeaders: null,
        },
        GetCustomerActiveFaxNumbers: {
          name: 'GetCustomerActiveFaxNumbers',
          path: '/GetCustomerActiveFaxNumbers',
          method: 'get',
          defaul_cach_time: 0,
          enable_message: false,
          // successMessage: "درخواست با موفقیت انجام شد",
          additionalHeaders: null,
        },
        GetFaxDownloadUrl: {
          name: 'GetFaxDownloadUrl',
          path: '/GetFaxDownloadUrl',
          method: 'get',
          defaul_cach_time: 0,
          enable_message: false,
          additionalHeaders: null,
        }
      }
    },
    Voicemail: {
      name: "api/Voicemail",
      actions: {
        GetInboxVoicemailsByFilter: {
          name: 'GetAllVoicemails',
          path: '/GetAllVoicemails',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        SetHeardByVoicemailId: {
          name: 'SetHeardByVoicemailId',
          path: '/SetHeardByVoicemailId',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
          successMessage: 'وضعیت شنیده شدن ایمیل صوتی تغییر کرد'
        },
        MoveToTrash: {
          name: 'MoveToTrash',
          path: '/MoveToTrash',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
          successMessage: 'ایمیل صوتی با موفقیت حذف شد'
        },
        GetAudioFile: {
          name: 'GetVoicemailAudioFile',
          path: '/GetVoicemailAudioFile',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetVoicemailBoxes: {
          name: 'GetVoicemailBoxes',
          path: '/GetVoicemailBoxes',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        }
      }
    },
    product: {
      name: "api/Product",
      actions: {
        getFreeSecretaryProduct: {
          name: 'getFreeSecretaryProduct',
          path: '/getFreeSecretaryProduct',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        getFreeIvrProduct: {
          name: 'getFreeIvrProduct',
          path: '/getFreeIvrProduct',
          method: 'get',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

      }
    },
    SaleCompany: {
      name: 'SaleCompany',
      actions: {
        GetAllCompany: {
          name: 'GetAllCompany',
          path: '/GetAllCompany',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        Add: {
          name: 'Add',
          path: '',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
      },

    },
    Calendar: {
      name: 'api/PersianHoliday',
      actions: {
        get: {
          name: 'get',
          path: '/GetAll',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: false,
        },
        add: {
          name: 'add',
          path: '/Insert',
          method: 'post',
          enable_message: true,
          successMessage: "درخواست با موفقیت انجام شد",
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        update: {
          name: 'update',
          path: '/Update',
          method: 'post',
          enable_message: true,
          successMessage: "درخواست با موفقیت انجام شد",
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        delete: {
          name: 'delete',
          path: '/Delete',
          method: 'post',
          enable_message: true,
          successMessage: "درخواست با موفقیت انجام شد",
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
      },

    },
    ContactCategory: {
      name: 'api/ContactCategory',
      actions: {
        getAllContactCategory: {
          name: 'Get',
          path: '/Get',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        addContactCategory: {
          name: 'AddContactCategory',
          path: '/AddContactCategory',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: 'عملیات با موفقیت انجام شد'
        },
        updateContactCategory: {
          name: 'UpdateContactCategory',
          path: '/UpdateContactCategory',
          method: 'patch',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: 'عملیات با موفقیت انجام شد'

        },
        removeContactCategory: {
          name: 'RemoveContactCategory',
          path: '/RemoveContactCategory',
          method: 'delete',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: 'عملیات با موفقیت انجام شد'

        },



      },

    },
    PhoneBook: {
      name: 'api/PhoneBook',
      actions: {
        get: {
          name: 'Get',
          path: '/Get',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        addPhoneBook: {
          name: 'addPhoneBook',
          path: '/addPhoneBook',
          method: 'post',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: 'عملیات با موفقیت انجام شد'
        },
        updatePhoneBook: {
          name: 'updatePhoneBook',
          path: '/updatePhoneBook',
          method: 'patch',
          defaul_cach_time: 0,
          additionalHeaders: null,
          enable_message: true,
          successMessage: 'عملیات با موفقیت انجام شد'

        },
        removePhoneBook: {
          name: 'RemovePhoneBook',
          path: '/RemovePhoneBook',
          method: 'delete',
          defaul_cach_time: 0,
          additionalHeaders: null,


        },



      },

    },
    Tickets: {
      name: 'api/Ticketing',
      actions: {
        GetTicketsByUser: {
          name: 'GetTicketsByUser',
          path: '/GetTicketsByUser',
          method: 'get',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        RegisterTicket: {
          name: 'RegisterTicket',
          path: '/RegisterTicket',
          method: 'post',
          enable_message: true,
          defaul_cach_time: 0,
          additionalHeaders: null,
          successMessage: 'تیکت  با موفقیت ثبت شد'
        },
        GetTicketResponsesById: {
          name: 'GetTicketResponsesById',
          path: '/GetTicketResponsesById',
          method: 'get',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        ReplyTicket: {
          name: 'ReplyTicket',
          path: '/ReplyTicket',
          method: 'put',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        }
      },
    },
    Customer: {
      name: 'api/Customer',
      actions: {
        GetCustomerFullName: {
          name: 'GetCustomerFullName',
          path: '/GetCustomerFullName',
          method: 'get',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        CheckExistsEmailByCustomerId: {
          name: 'CheckExistsEmailByCustomerId',
          path: '/CheckExistsEmailByCustomerId',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
      }
    },
    OutgoingCall: {
      name: 'api/OutgoingCall',
      actions: {
        OutgoingCall: {
          name: 'OutgoingCall',
          path: '/OutgoingCall',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
      }
    },
    CallQueueActiveCall: {
      name: 'api/CallQueueActiveCall',
      actions: {
        GetStatusCallQueueById: {
          name: 'GetStatusCallQueueById',
          path: '/GetStatusCallQueueById',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetAllCallQueue: {
          name: 'GetAllCallQueue',
          path: '/GetAllCallQueue',
          method: 'get',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        ReportActiveCallQueue: {
          name: 'ReportActiveCallQueue',
          path: '/ReportActiveCallQueue',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        WeeklyReportCallQueue: {
          name: 'WeeklyReportCallQueue',
          path: '/WeeklyReportCallQueue',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },

        GetReportActiveCallForAllQueue: {
          name: 'GetReportActiveCallForAllQueue',
          path: '/GetReportActiveCallForAllQueue',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
      }
    },
    CallRating: {
      name: 'api/CallRating',
      actions: {
        GetCallRatingSettings: {
          name: 'GetCallRatingSettings',
          path: '/GetCallRatingSettings',
          method: 'get',
          enable_message: true,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        EditCallRatingSetting: {
          name: 'EditCallRatingSetting',
          path: '/EditCallRatingSetting',
          method: 'post',
          enable_message: true,
          defaul_cach_time: 0,
          additionalHeaders: null,
          successMessage: "تنظیمات با موفقیت انجام شد"
        }
      }
    },
    CustomerCallRating: {
      name: 'api/CustomerCallRating',
      actions: {
        GetCustomerCallRatings: {
          name: 'GetCustomerCallRatings',
          path: '/GetCustomerCallRatings',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetRatingStatistics: {
          name: 'GetRatingStatistics',
          path: '/GetRatingStatistics',
          method: 'post',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        }
      }
    },
    OutGoingOnSecretary: {
      name: 'api/CustomerLine',
      actions: {
        SetSecretarySettings: {
          name: 'SetSecretarySettings',
          path: '/SetSecretarySettings',
          method: 'post',
          // enable_message: true,
          defaul_cach_time: 0,
          additionalHeaders: null,
        },
        GetSecretarySettings: {
          name: 'GetSecretarySettings',
          path: '/GetSecretarySettings',
          method: 'get',
          enable_message: false,
          defaul_cach_time: 0,
          additionalHeaders: null,
        }
      }
    }

  }
}
export default RequestManager;

export const getRequestRequirement = (path) => {
  let resPath = '';
  let action = {};
  const splitedPath = path.split('.')
  const controller = RequestManager.controllers;
  if (controller[splitedPath[0]]) {
    resPath = controller[splitedPath[0]].name
    const actions = controller[splitedPath[0]].actions;
    if (actions[splitedPath[1]]) {
      action = actions[splitedPath[1]];
      resPath += actions[splitedPath[1]].path
    }
  }
  return { path: resPath, action };
}
